import { createContext, useContext, useState, type ReactNode } from 'react';

/**
 * Demo mode — a public build where features that spend real money or touch real
 * data are locked behind an "only in the full version" wall rather than a plain
 * error. A costly control calls showPaid() to route the visitor to the upsell.
 */
interface DemoState {
  demo: boolean;
  showPaid: () => void;
}
const Ctx = createContext<DemoState>({ demo: false, showPaid: () => undefined });
export const useDemo = (): DemoState => useContext(Ctx);

export function DemoProvider({ demo, children }: { demo: boolean; children: ReactNode }) {
  const [paidOpen, setPaidOpen] = useState(false);
  return (
    <Ctx.Provider value={{ demo, showPaid: () => setPaidOpen(true) }}>
      {demo && (
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 50,
            textAlign: 'center',
            padding: '6px 12px',
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: 0.4,
            color: '#ffffff',
            background: 'linear-gradient(90deg, #c64a08, #e8590c 55%, #f4884a)',
          }}
        >
          🔎 DEMO — sample data. Some actions are reserved for the full version.
        </div>
      )}
      {children}
      {paidOpen && <PaidOnlyModal onClose={() => setPaidOpen(false)} />}
    </Ctx.Provider>
  );
}

function PaidOnlyModal({ onClose }: { onClose: () => void }) {
  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'grid', placeItems: 'center', zIndex: 1000, padding: 20 }}
    >
      <div onClick={(e) => e.stopPropagation()} className="panel" style={{ maxWidth: 460, textAlign: 'center', padding: 32 }}>
        <div style={{ fontSize: 44 }}>🔒</div>
        <h2 style={{ margin: '10px 0 0' }}>Only in the full version</h2>
        <p className="muted" style={{ marginTop: 10, fontSize: 15, lineHeight: 1.5 }}>
          This is a live demo. Features that train models on real GPUs — or send real data — are
          reserved for the paid version. Everything else here is yours to explore.
        </p>
        <div className="row" style={{ justifyContent: 'center', gap: 10, marginTop: 22 }}>
          <a className="btn primary" href="https://thevisionqc.com/contact">Get full access</a>
          <button className="btn" onClick={onClose}>Keep exploring</button>
        </div>
      </div>
    </div>
  );
}
